const BASE_URL = '/api/collections/references/entries';

export default (locale) => ({
  testimonials: [],
  methodicsWithReferences: [],
  filter: {
    field: '',
    methodic: '',
    sort: 'desc',
  },
  filterActive: false,

  get filteredTestimonials() {
    let ret = this.testimonials;
    if (this.filter.field) {
      ret = ret.filter((testimonial) =>
        testimonial.fields.some((field) => field.slug === this.filter.field)
      );
    }
    if (this.filter.methodic) {
      ret = ret.filter((testimonial) =>
        testimonial.methodics.some(
          (methodic) => methodic.slug === this.filter.methodic
        )
      );
    }
    ret = ret.sort((a, b) => {
      if (this.filter.sort === 'asc') {
        return new Date(a.date) - new Date(b.date);
      }
      return new Date(b.date) - new Date(a.date);
    });
    return ret;
  },

  resetFilter() {
    this.filter.field = '';
    this.filter.methodic = '';
    this.filter.sort = 'desc';
    this.filterActive = false;

    this.$nextTick(() => {
      $('select.form-input').each((index, item) => {
        item.sumo.reload();
      });
    });
  },

  init() {
    fetch(`${BASE_URL}?filter[locale:is]=${locale}&sort=-date`)
      .then((response) => response.json())
      .then((response) => {
        this.testimonials = response.data;
        console.log('API Response:', response.data[0]); // Debug first testimonial
        this.extractMethodicsWithReferences();
      });
  },

  extractMethodicsWithReferences() {
    const methodicSet = new Set();
    console.log('Extracting methodics from testimonials...');
    this.testimonials.forEach((testimonial) => {
      console.log(`Processing: ${testimonial.title}, methodics:`, testimonial.methodics);
      if (testimonial.methodics) {
        testimonial.methodics.forEach((methodic) => {
          console.log('Adding methodic:', methodic);
          methodicSet.add(JSON.stringify(methodic));
        });
      }
    });
    this.methodicsWithReferences = Array.from(methodicSet).map((methodicString) =>
      JSON.parse(methodicString)
    );
    console.log('Final methodicsWithReferences:', this.methodicsWithReferences);
  },
});
